<template>
    <div>
        <vx-card no-shadow>
            <vs-button v-if="!customer_id" class="float-right mb-2" @click.stop="onClickCreate">Create new order</vs-button>
            <vs-table :data="data_list">
                <template slot="thead">
                    <vs-th>DATE/TIME</vs-th>
                    <vs-th>ORDER CODE</vs-th>
                    <vs-th>COUNTRY</vs-th>
                    <vs-th>ORDER STATUS</vs-th>
                    <vs-th>ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].created_at">
                            {{ __dateTimeFormatter(data[indextr].created_at) }}
                        </vs-td>

                        <vs-td :data="data[indextr].sample_order_code">
                            {{ data[indextr].sample_order_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].country">
                            {{ data[indextr].country }}
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip>
                                {{ data[indextr].status.name }}
                            </vs-chip>
                        </vs-td>

                        <vs-td>
                            <div class="vx-row">
                                <vx-tooltip class="mr-2" text="VIEW ORDER" position="top" v-can="'view-sample-order'">
                                    <vs-button @click.stop="onClickSampleOrderView(data[indextr].id)" size="small"
                                        color="primary" type="border" icon-pack="feather"
                                        icon="icon-external-link"></vs-button>
                                </vx-tooltip>
                            </div>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CustomerRepository = RepositoryFactory.get('customer');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
export default {
    name: 'LeadSampleOders',
    data() {
        return {
            id: '',
            data_list: [],
        }
    },
    props: {
        customer_id: {
            default: null,
        }
    },
    methods: {
        async fetchLeadSampleOrders() {
            try {
                const { data } = await CustomerRepository.getListOfSamplesForLead(this.id)
                this.data_list = data.data
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
        async onClickSampleOrderView(id) {
            let route = this.$router.resolve({ path: `/pages/sample-orders/${id}` });
            window.open(route.href, '_blank');
        },
        onClickCreate() {
            localStorage.setItem('redirect_url', window.location.pathname + '?step=3')
            this.$router.push(`/pages/sample-orders?create=${this.id}`)
        }
    },
    async mounted() {
        this.id = this.$route.params.id
        await this.fetchLeadSampleOrders()
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
<style lang="">
    
</style>